module.exports = __webpack_public_path__ + "01479c300c15b924494d88f6a133361d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar-city-choice-buildings-screen.png
// module id = 357
// module chunks = 0